// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import searchIcon from '../../../../images/search.png';
import styles from './styles';

class SearchBar extends Component {
  static propTypes = {
    classes: PropTypes.object,
    questions: PropTypes.array,
    onSearch: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    questions: [],
    onSearch: () => { },
  };

  onSearch = (event) => {
    const text = event.target.value;
    const filter = text.toLowerCase();
    const { questions, onSearch } = this.props;
    const filteredQuestions = questions.filter(el => (el.title
      && el.title.toLowerCase().indexOf(filter) >= 0)
      || (el.text && el.text.toLowerCase().indexOf(filter) >= 0));
    onSearch(filteredQuestions);
  }

  onKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 13) {
      this.onSearch(event);
    }
    return null;
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainContainer}>
        <div className={classes.inputContainer}>
          <img className={classes.searchIcon} src={searchIcon} alt={'search'} />
          <input
            className={classes.input}
            placeholder={'Search..'}
            onKeyPress={event => this.onKeyPress(event)}
            onChange={this.onSearch}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(SearchBar);
